"use client";

import React from "react";

import { iconColor } from "../colors";
import { createSVGIcon } from "../createSVGIcon";
import { iconCls } from "../tracking";

/**
 * @figma designed by Gabe Kelley, Nick Howland (see [Figma](https://figma.com/file/qcB5qVN7uKBBYHN49ihDE7?node-id=7688%3A1005))
 * @lastsynced 2026-10-29T13:52:14.205Z
 * @trackcomponent
 * @optimized using svgo:^3.3.4
 */
export const ImageSearch = createSVGIcon(
  <path
    d="M23 11V8c0-1.105-.938-2-2.095-2h-2.022c-.7 0-1.384-1.334-1.773-1.89L16.5 3c-.389-.556-.8-1-1.5-1H9.2c-.794 0-1.455.322-1.81 1l-.49.894C6.545 4.572 5.737 6 4.943 6H3.095C1.938 6 1 6.895 1 8v3m15 11h4.905C22.062 22 23 21.105 23 20v-4M8 22H3.095C1.938 22 1 21.105 1 20v-4m15-3a4 4 0 1 1-8 0 4 4 0 0 1 8 0Z"
    strokeLinecap="round"
    stroke="currentColor"
  />,
  "ImageSearch",
  {
    color: iconColor.primary,
    fill: "none",
    viewBox: "0 0 24 24",
    className: iconCls(),
  } // This icon is decorative, keep titleAccess empty so it doesn't clutter the screenreader experience
);
